import { PDFDocument, StandardFonts } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import { drawTextOnPage, truncateText } from "./StaticPdfUtils";

// PDF Path
const PDF = "/static/pdf/printList/patient_phon_fol.pdf";
const Font = "/static/fonts/THSarabunNew-Bold.ttf"; //* กรณีแก้ Font

const FormPatientPhoneFollowUp = async (props: any) => {
  try {
    const existingPdfBytes = await fetch(PDF).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    // Loading Custom Font
    const fontUrl = Font;
    const fontBytes = await fetch(fontUrl).then((res) => res.arrayBuffer());
    pdfDoc.registerFontkit(fontkit);
    const customFont = await pdfDoc.embedFont(fontBytes);
    const zapFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

    const pages = pdfDoc.getPages();
    const fontSize = 13; //*

    // Page 1
    const pageOneCoordinates = [
      { text: props.items?.patientFullName, x: 364, y: 811 },
      { text: props.items?.hn, x: 352, y: 792 },
      { text: props.items?.patientEncounter, x: 476, y: 792 },
      { text: props.items?.birthdateAd, x: 380, y: 773 },
      { text: props.items?.age.toString(), x: 480, y: 773 },
      { text: props.items?.formatGender, x: 539, y: 773 },
      { text: props.items?.doctorFullName || "-", x: 379, y: 753 },
      { text: truncateText(props.items?.allergies, customFont, fontSize, 372, 570), x: 372, y: 733 }
    ];

    drawTextOnPage(pages[0], pageOneCoordinates, customFont, fontSize);

    const modifiedPdfBytes = await pdfDoc.save();
    const getAsBase64 = await pdfDoc.saveAsBase64();
    const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
    const modifiedPdfUrl = URL.createObjectURL(blob);

    return { uint8Array: modifiedPdfBytes, blobUrl: modifiedPdfUrl, blobRaw: blob, base64String: getAsBase64 }

  } catch (error) {
    console.error("Error modifying PDF: ", error);
    return {};
  }
};

export default FormPatientPhoneFollowUp;